import { Component } from '@angular/core';

import { EnumPluginProvider } from 'app/domains/aya/enums/plugin-provider.enum';

interface IPluginProviderGuide {
  provider: EnumPluginProvider;
  label: string;
  steps: string[];
  note?: string;
  docs?: { label: string; url: string };
}

@Component({
  selector: 'sgt-plugin-section',
  templateUrl: './plugin-section.component.html',
  styleUrls: ['./plugin-section.component.scss'],
})
export class PluginSectionComponent {
  readonly guides: IPluginProviderGuide[] = [
    {
      provider: EnumPluginProvider.Claude,
      label: 'Claude',
      steps: [
        'Abra o Claude e acesse <strong>Customize → Connectors</strong>. Nas contas com a interface nova, procure <strong>Plugins</strong> e o filtro de conectores.',
        'Clique em <strong>+ Add → Add custom connector</strong>.',
        'Preencha o nome <strong>AyA</strong> e cole a <strong>URL do MCP</strong> fornecida pela Sogitec.',
        'Clique em <strong>Continue</strong> e confira a autenticação detectada.',
        'Escolha <strong>Sign in now</strong> para conectar naquele momento. A configuração do cliente OAuth deve seguir o que o servidor da AyA suporta.',
        'Conclua em <strong>Add</strong> e faça login com sua <strong>conta SogiVendas</strong> quando solicitado.',
        'Na conversa, abra <strong>+ → Connectors</strong> e habilite a <strong>AyA</strong>.',
        'Envie sua pergunta.',
      ],
    },
    {
      provider: EnumPluginProvider.ChatGpt,
      label: 'ChatGPT',
      steps: [
        'Abra o ChatGPT pelo navegador e entre em <strong>Plugins</strong>.',
        'Clique em <strong>+ → Add custom MCP server</strong> — adicionar servidor MCP personalizado.',
        'No nome, preencha <strong>AyA</strong>.',
        'Em <strong>Server URL</strong>, cole a <strong>URL do MCP da AyA</strong> fornecida pela Sogitec.',
        'Selecione a autenticação <strong>OAuth</strong> e use a configuração indicada para esse servidor.',
        'Leia o aviso apresentado, confirme e clique em <strong>Create as a plugin</strong>.',
        'Localize a AyA nos plugins pessoais ou do workspace e instale. Quando solicitado, faça login com sua <strong>conta SogiVendas</strong> e autorize a conexão.',
        'Abra uma conversa nova, digite <strong>@</strong>, selecione <strong>AyA</strong> e envie sua pergunta.',
      ],
      note: 'Esse é o caminho documentado atualmente pela OpenAI; a disponibilidade depende das permissões da conta e do workspace.',
      docs: {
        label: 'Documentação oficial da OpenAI',
        url: 'https://developers.openai.com/api/docs/guides/custom-mcp-server',
      },
    },
  ];

  activeProvider = EnumPluginProvider.Claude;

  selectProvider(provider: EnumPluginProvider): void {
    this.activeProvider = provider;
  }

  get activeGuide(): IPluginProviderGuide {
    return this.guides.find(guide => guide.provider === this.activeProvider) ?? this.guides[0];
  }
}
